/*
 * btb-sparklayer-bridge.js
 *
 * For B2B-authenticated users the visible variant picker lives inside <spark-pdp>'s
 * shadow DOM, so Dawn's <variant-selects> never fires 'variant-change' and every
 * sibling section (breadcrumb SKU, btb-product-details, media-gallery, variant-image-filter)
 * stays frozen on the initial variant. This bridge listens for SparkLayer's
 * 'spark-variant-change' event on <spark-pdp>, fetches the refreshed main section,
 * swaps the gallery, and republishes Dawn's pubsub 'variant-change' so all existing
 * subscribers keep working unchanged.
 *
 * Depends on window.btbProductVariants / btbProductSectionId / btbProductUrl
 * (rendered inline by sections/main-product.liquid) and on pubsub.js's global
 * publish() function.
 */
(function () {
  var TAG = '[BTB-SPARK-BRIDGE]';

  // Track which variant we've already handled so we don't refetch on the initial
  // event SparkLayer fires for the page's starting variant.
  var initialVariantId = (function () {
    try {
      var p = new URLSearchParams(window.location.search).get('variant');
      return p ? parseInt(p, 10) : null;
    } catch (e) { return null; }
  })();
  var lastHandledId = initialVariantId;

  if (!window.SparkOptions) window.SparkOptions = {};
  var priorOnReady = window.SparkOptions.onReady;
  window.SparkOptions.onReady = function () {
    if (typeof priorOnReady === 'function') {
      try { priorOnReady.apply(this, arguments); } catch (e) { console.warn(TAG, 'prior onReady threw', e); }
    }
    bindBridge('onReady');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bindBridge('DOMContentLoaded'); });
  } else {
    bindBridge('immediate');
  }
  window.addEventListener('load', function () { bindBridge('load'); });

  function bindBridge(source) {
    var pdps = document.querySelectorAll('spark-pdp');
    if (!pdps.length) return;
    pdps.forEach(function (pdp) {
      if (pdp.__btbBridged) return;
      pdp.__btbBridged = true;
      pdp.addEventListener('spark-variant-change', onSparkVariantChange);
    });
  }

  function onSparkVariantChange(event) {
    var externalId = event && event.detail && event.detail.variant && event.detail.variant.externalId;
    if (!externalId) return;
    var variantId = parseInt(String(externalId), 10);
    if (!Number.isFinite(variantId)) return;

    if (variantId === lastHandledId) return;
    lastHandledId = variantId;

    var variants = window.btbProductVariants || [];
    var variant = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i] && variants[i].id === variantId) { variant = variants[i]; break; }
    }
    if (!variant) {
      console.warn(TAG, 'no Shopify variant for id', variantId, '— is window.btbProductVariants rendered?');
      return;
    }

    if (window.history && window.history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', String(variantId));
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* ignore */ }
    }

    var sectionId = window.btbProductSectionId;
    var productUrl = window.btbProductUrl;
    if (!sectionId || !productUrl) {
      publishBridge(variant, null, sectionId);
      return;
    }

    fetch(productUrl + '?variant=' + variantId + '&section_id=' + encodeURIComponent(sectionId), {
      credentials: 'same-origin'
    })
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var parsed = new DOMParser().parseFromString(text, 'text/html');

        var galleryId = 'MediaGallery-' + sectionId;
        var tgtGallery = document.getElementById(galleryId);
        var srcGallery = parsed.getElementById(galleryId);
        if (tgtGallery && srcGallery && tgtGallery.parentNode) {
          tgtGallery.parentNode.replaceChild(srcGallery, tgtGallery);
        }

        publishBridge(variant, parsed, sectionId);
      })
      .catch(function (e) {
        console.warn(TAG, 'section fetch failed; publishing without html', e);
        publishBridge(variant, null, sectionId);
      });
  }

  function publishBridge(variant, html, sectionId) {
    if (typeof publish !== 'function') return;
    publish('variant-change', { data: { variant: variant, sectionId: sectionId, html: html } });
  }
})();
